/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { isAcceptedLiveWidget } from '../../../util/ExtVisUtil';
import { showUnsupportedExtVisToast } from '../../../util/ToastUtil';
const BasePinsPanel = require('gemini/pinning/PinsPanel');
/**
* Remove unsupported vis for Explore from the dashboard spec widgets
* @param {object} spec - spec.widgets is an array  of widget models in dashboard spec
* @param {object} glassContext - to show the toast message if pin contains customVis
*/
const filterOutUnsupportedVis = (spec, glassContext) => {
	if (!spec.widgets || !spec.widgets.length) {
		return;
	}
	const supportedLiveWidgets = [];
	let customVisCount = 0;
	spec.widgets.forEach(widget => {
		if (isAcceptedLiveWidget(widget)) {
			supportedLiveWidgets.push(widget);
		} else if (widget.isExtVis) {
			customVisCount++;
		}
	});
	spec.widgets = supportedLiveWidgets;
	if (customVisCount) {
		showUnsupportedExtVisToast(glassContext);
	}
};

const PinsPanel = BasePinsPanel.extend({
	_addPinToLayout: function({ model: widgetFragment }) {

		// The conversion DashboardToExplore doesn't remove properly customVis & customWidgets, 
		// hence do it here before calling the conversion
		filterOutUnsupportedVis(widgetFragment, this.glassContext);
		if (!widgetFragment.widgets || !widgetFragment.widgets.length) {
			// no widgets in fragment spec or all widgets are unsupported vis and have been removed from the spec
			return Promise.resolve();
		}
		return this.dashboardApi.getGlassSvc('.ConversionService')
			.then(conversionSvc => conversionSvc.convert('DASHBOARD', 'EXPLORE', JSON.stringify(widgetFragment)))
			.then(spec => {
				let options;
				// after filtering unsupported pins, converter may return the string "null" for empty result
				if (spec !== 'null') {
					const specJson = JSON.parse(spec);
					options = {
						insertBefore: null,
						parentId: null,
						model: specJson
					};
					if (!Array.isArray(options.model.widgets)) {
						options.model.widgets = Object.values(options.model.widgets);
					}
					if (options.model.layout.items) {
						options.model.layout = Object.values(options.model.layout.items);
					}
				}
				return options;
			})
			.then(options => {
				if (options) {
					this.canvasController.getDeprecatedCanvas().addFragment(options);
					if (options.model.widgets.length) {
						// If there are many widgets added, display the first card in Explore container
						const content = this.dashboardApi.getCanvas().getContent(options.model.widgets[0].id);
						if (content) {
							const contentView = this.glassContext.appController.getCurrentContentView();
							const cardId = content.getContainer().getId();
							contentView && contentView.getExploreApi().setDisplayedToCard(cardId);
						}
					}
				}
			});
	}
});

export default PinsPanel;



// WEBPACK FOOTER //
// ./src/js/glass/extensions/pinning/PinsPanel.js